const GENERIC_INVALID_CREDENTIALS = 'Invalid username, email, or password.';
const LOCAL_AUTH_UNAVAILABLE =
  'Local authentication is unavailable. Restart the test server with pnpm.cmd run dev:test, then try again.';

const GENERIC_CREDENTIAL_CODES = new Set([
  'auth/wrong-password',
  'auth/user-not-found',
  'auth/invalid-credential',
  'auth/invalid-email',
  'username/not-found',
]);

const LOCAL_AUTH_UNAVAILABLE_CODES = new Set([
  'username/resolver-unavailable',
  'auth/network-request-failed',
  'LOCAL_AUTH_BRIDGE_FAILED',
  'LOCAL_AUTH_UNAVAILABLE',
]);

export function mapAuthErrorToMessage(error: unknown): string {
  const code = typeof error === 'object' && error !== null && 'code' in error
    ? String((error as { code?: unknown }).code)
    : '';

  if (LOCAL_AUTH_UNAVAILABLE_CODES.has(code)) {
    return LOCAL_AUTH_UNAVAILABLE;
  }

  if (GENERIC_CREDENTIAL_CODES.has(code)) {
    return GENERIC_INVALID_CREDENTIALS;
  }

  return 'Unable to complete sign-in. Please try again.';
}
